import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { setCalendarLoadState } from '../actions/setCalendarLoadState';

/**
 * Sets loading state for given calendar
 */
mutator(setCalendarLoadState, actionMessage => {
    const { calendarId, loadingState } = actionMessage;
    let store = getStore();
    store.calendarLoadingState.set(calendarId.id, loadingState);
});
